/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { MenuOrderOwn } from './MenuOrderOwn';
import {
    MenuOrderOwnFromJSON,
    MenuOrderOwnFromJSONTyped,
    MenuOrderOwnToJSON,
    MenuOrderOwnToJSONTyped,
} from './MenuOrderOwn';

/**
 * 
 * @export
 * @interface GetMenuOrdersOwnResponse
 */
export interface GetMenuOrdersOwnResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetMenuOrdersOwnResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<MenuOrderOwn>}
     * @memberof GetMenuOrdersOwnResponse
     */
    menuOrders: Array<MenuOrderOwn>;
}

/**
 * Check if a given object implements the GetMenuOrdersOwnResponse interface.
 */
export function instanceOfGetMenuOrdersOwnResponse(value: object): value is GetMenuOrdersOwnResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('menuOrders' in value) || value['menuOrders'] === undefined) return false;
    return true;
}

export function GetMenuOrdersOwnResponseFromJSON(json: any): GetMenuOrdersOwnResponse {
    return GetMenuOrdersOwnResponseFromJSONTyped(json, false);
}

export function GetMenuOrdersOwnResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuOrdersOwnResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'menuOrders': ((json['menuOrders'] as Array<any>).map(MenuOrderOwnFromJSON)),
    };
}

export function GetMenuOrdersOwnResponseToJSON(json: any): GetMenuOrdersOwnResponse {
    return GetMenuOrdersOwnResponseToJSONTyped(json, false);
}

export function GetMenuOrdersOwnResponseToJSONTyped(value?: GetMenuOrdersOwnResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'menuOrders': ((value['menuOrders'] as Array<any>).map(MenuOrderOwnToJSON)),
    };
}

